import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { HomecardLabel } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';

import '@spotahome/ui-library/lib/components/Homecard/common/HomecardLabel.css';

import './HomeCardLabels.scss';

const HomeCardLabels = ({ checked, isSuperlister, isSelect }) => (
  <Fragment>
    {checked && (
      <HomecardLabel
        renderContent={() => trans('homecard.label.checked')}
        className="label--checked"
      />
    )}
    {isSuperlister && !isSelect && (
      <HomecardLabel
        renderContent={() => trans('homecard.label.top_lister')}
        className="label--super-lister"
      />
    )}
    {isSelect && (
      <HomecardLabel
        renderContent={() => trans('homecard.label.select')}
        className="label--select"
      />
    )}
  </Fragment>
);

HomeCardLabels.propTypes = {
  checked: PropTypes.bool.isRequired,
  isSuperlister: PropTypes.bool.isRequired,
  isSelect: PropTypes.bool.isRequired
};

export const generateHomeCardLabels = ({
  checked,
  isSuperlister,
  isSelect
}) => () => (
  <HomeCardLabels
    checked={checked}
    isSuperlister={isSuperlister}
    isSelect={isSelect}
  />
);

export default generateHomeCardLabels;
